import { render, staticRenderFns } from "./TheClientPortal.vue?vue&type=template&id=de5ac844&scoped=true"
import script from "./TheClientPortal.vue?vue&type=script&lang=ts"
export * from "./TheClientPortal.vue?vue&type=script&lang=ts"
import style0 from "./TheClientPortal.vue?vue&type=style&index=0&id=de5ac844&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5ac844",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de5ac844')) {
      api.createRecord('de5ac844', component.options)
    } else {
      api.reload('de5ac844', component.options)
    }
    module.hot.accept("./TheClientPortal.vue?vue&type=template&id=de5ac844&scoped=true", function () {
      api.rerender('de5ac844', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TheClientPortal.vue"
export default component.exports